"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarAnimation = exports.ProgressBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ProgressBar = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 1px solid #ddd;\n    height: 30px;\n    width: 100%;\n    border-radius: 3px;\n    color: #333;\n    text-align: center;\n    line-height: 30px;\n    transition: all 0.5s ease-in-out;\n"])));

exports.ProgressBar = ProgressBar;

var ProgressBarAnimation = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    left: -46px;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: -1;\n\n    background: -webkit-repeating-linear-gradient(\n        145deg,\n        #338ce4 1px,\n        #97cafc 2px,\n        #97cafc 11px,\n        #338ce4 12px,\n        #338ce4 20px\n    );\n    background: repeating-linear-gradient(\n        -55deg,\n        #338ce4 1px,\n        #97cafc 2px,\n        #97cafc 11px,\n        #338ce4 12px,\n        #338ce4 20px\n    );\n\n    -webkit-animation-name: animatedBg;\n    -webkit-animation-duration: 1s;\n    -webkit-animation-timing-function: linear;\n    -webkit-animation-iteration-count: infinite;\n\n    animation-name: animatedBg;\n    animation-duration: 1s;\n    animation-timing-function: linear;\n    animation-iteration-count: infinite;\n\n    @-webkit-keyframes animatedBg {\n        from {\n            -webkit-transform: translateX(0);\n        }\n        to {\n            -webkit-transform: translateX(46px);\n        }\n    }\n\n    @keyframes animatedBg {\n        from {\n            transform: translateX(0);\n        }\n        to {\n            transform: translateX(46px);\n        }\n    }\n"])));

exports.ProgressBarAnimation = ProgressBarAnimation;